import { render } from "./HotelReservationItem.vue?vue&type=template&id=02248465&scoped=true"
import script from "./HotelReservationItem.vue?vue&type=script&lang=js"
export * from "./HotelReservationItem.vue?vue&type=script&lang=js"

import "./HotelReservationItem.vue?vue&type=style&index=0&id=02248465&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02248465"]])

export default __exports__